module.exports = __webpack_public_path__ + "static/04-1bbb75b8047c4344f5ce65e4519a3bca.jpg";